webpackJsonp([46],{

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(52)(
  /* script */
  __webpack_require__(755),
  /* template */
  __webpack_require__(848),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // common
      lAction: '',
      sAction: '',
      lAcType: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      handy: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a,
      rules: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.rules,
      beingSaved: false,
      fab: false,

      // screen specific
      lAcc: '',
      accs: [],
      types: ['Bank', 'Cash'],
      bankTypes: ['Savings', 'Current', 'Deposit', 'Loan'],
      accHead: [{ text: 'A/C Name', value: 'bc_acc_name', width: '200px' }, { text: 'Balance', value: 'cur_bal' }],
      accHeadSm: [{ text: 'A/C Name', value: 'bc_acc_name', width: '200px' }, { text: 'Type', value: 'bank_acc_type', width: '50px' }, { text: 'Balance', value: 'cur_bal', width: '50px' }],
      incomeHeads: [],
      expHeads: []
    };
  },
  // data
  created: function created() {
    this.loadAccs();
    this.loadIncomeExpHeads();
    this.lAction = 'view';
  },

  methods: {
    // common methods
    msg: function msg(m) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.sbarCol = isError ? 'error' : 'success';
      this.sbar = true;
      this.sbarMsg = m;
    },

    // screen specific methods
    loadAccs: function loadAccs() {
      var _this = this;

      // existing accounts
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getBankCashAccountsByCommId/', qry).then(function (response) {
        _this.accs = response.data;
      }).catch(function (err) {
        _this.msg(err.response.data, true);
        _this.accs = [];
      });
    },
    loadIncomeExpHeads: function loadIncomeExpHeads() {
      var _this2 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncomeExpenseHeadsByCommId/', qry).then(function (response) {
        _this2.incomeHeads = response.data.filter(function (rec) {
          return rec.gl_acc_type === 'INCOME';
        });
        _this2.expHeads = response.data.filter(function (rec) {
          return rec.gl_acc_type === 'EXPENSE';
        });
      }).catch(function (err) {
        _this2.msg(err.response.data, true);
        _this2.incomeHeads = [];
        _this2.expHeads = [];
      });
    },
    prepareUpdate: function prepareUpdate(curAcc) {
      var _this3 = this;

      this.lAcc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, curAcc); // keep the original object safely before changes
      this.lAcc.bc_acc_bal = Math.abs(this.lAcc.tot_debit_amount - this.lAcc.tot_credit_amount);
      this.lAcc.prev_acc_bal = this.lAcc.bc_acc_bal;
      this.lAcc.prev_acc_name = this.lAcc.bc_acc_name;
      this.lAcc.prev_acc_type = this.lAcc.bank_acc_type;
      this.lAcc.debit_gl_acc_id = '';
      this.lAcc.credit_gl_acc_id = '';
      this.lAcc.bal_diff = 0;
      // allow to update the opening balance in case there is no other transaction
      var qry = {
        params: {
          gl_acc_id: this.lAcc.gl_acc_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getTotTransByAccId/', qry).then(function (response) {
        _this3.lAcc.no_tran_yet = response.data[0].tot === 0;
        _this3.lAcc.no_op_bal_yet = !_this3.lAcc.tot_debit_amount && !_this3.lAcc.tot_credit_amount;
        _this3.lAction = 'update';
        _this3.sAction = '';
      });
    },
    prepareCreate: function prepareCreate(curType) {
      this.lAcc = this.getEmptyAcc();
      this.lAcc.bc_acc_type = curType;
      this.lAction = 'create';
      this.sAction = '';
      this.fab = false;
    },
    updateBal: function updateBal() {
      this.lAcc.bal_diff = this.lAcc.bc_acc_bal - this.lAcc.prev_acc_bal;
      this.lAcc.bal_changed = this.lAcc.bal_diff !== 0;
      this.$forceUpdate();
    },
    getEmptyAcc: function getEmptyAcc() {
      var emptyAcc = {
        comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
        gl_acc_id: -1,
        bc_acc_name: '',
        bc_acc_type: '',
        bc_acc_bal: '',
        bank_acc_type: '',
        is_alert_min_bal: false,
        no_tran_yet: true
      };
      return emptyAcc;
    },
    saveChanges: function saveChanges(curAct) {
      var _this4 = this;

      if (curAct !== 'delete') {
        if (!this.$refs.lForm.validate()) {
          return;
        }
        this.lAcc.bc_acc_bal = this.lAcc.bc_acc_bal || 0;
      }
      this.beingSaved = true;
      // pre-req
      if (curAct === 'update') {
        if (this.lAcc.prev_acc_name !== this.lAcc.bc_acc_name || this.lAcc.prev_acc_type !== this.lAcc.bank_acc_type) {
          this.lAcc.gl_attr_changed = true;
        } else {
          this.lAcc.gl_attr_changed = false;
        }
      }

      if (this.lAcc.debit_gl_acc_id && this.lAcc.debit_gl_acc_id.gl_acc_name) {
        this.lAcc.debit_gl_acc_name = this.lAcc.debit_gl_acc_id.gl_acc_name;
        this.lAcc.debit_gl_acc_id = this.lAcc.debit_gl_acc_id.gl_acc_id;
      }
      if (this.lAcc.credit_gl_acc_id && this.lAcc.credit_gl_acc_id.gl_acc_name) {
        this.lAcc.credit_gl_acc_name = this.lAcc.credit_gl_acc_id.gl_acc_name;
        this.lAcc.credit_gl_acc_id = this.lAcc.credit_gl_acc_id.gl_acc_id;
      }

      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/bank/' + curAct, this.lAcc).then(function (response) {
        // update the frontend
        _this4.loadAccs();
        _this4.lAction = 'view';
        _this4.beingSaved = false;
      }).catch(function (err) {
        _this4.msg(err.response.data, true);
        _this4.beingSaved = false;
      });
    },
    cancelChanges: function cancelChanges() {
      this.lAction = 'view';
    },
    deleteAcc: function deleteAcc() {
      // confirm
      if (confirm('Sure, you want to delete the account "' + this.lAcc.bc_acc_name + '"?')) {
        // delete
        this.saveChanges('delete');
      }
    }
  } // methods
  // export

});

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_vm._l((_vm.types), function(hType, t) {
    return _c('div', {
      key: t
    }, [_c('v-card', {
      staticClass: "mb-3 ma-1"
    }, [_c('v-card-title', {
      staticClass: "pa-2 grey lighten-4"
    }, [_c('div', {
      staticClass: "title grey--text"
    }, [_vm._v(_vm._s(hType))])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0"
    }, [_c('v-data-table', {
      staticClass: "elevation-0",
      attrs: {
        "headers": !_vm.$vuetify.breakpoint.smAndUp || t === 1 ? _vm.accHead : _vm.accHeadSm,
        "items": _vm.accs.filter(function (rec) { return rec.bc_acc_type === hType; }),
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdate(props.item)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(props.item.bc_acc_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp && t === 0) ? _c('td', [_vm._v(_vm._s(props.item.bank_acc_type))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.handy.formatCur(Math.abs(props.item.tot_debit_amount - props.item.tot_credit_amount))))])])]
        }
      }], null, true)
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-speed-dial', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "accent",
      "dark": "",
      "fab": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.prepareCreate('Bank')
      }
    }
  }, [_c('v-icon', [_vm._v("account_balance")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "color": "indigo"
    },
    on: {
      "click": function($event) {
        return _vm.prepareCreate('Cash')
      }
    }
  }, [_c('v-icon', [_vm._v("money")])], 1)], 1)], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n                " + _vm._s(_vm.handy.startWithUpper(_vm.lAction) + (_vm.lAcc.bc_acc_type ? ' ' + _vm.handy.startWithUpper(_vm.lAcc.bc_acc_type) : '')) + " Account\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Account name",
      "rules": [_vm.rules.required],
      "hint": _vm.lAcc.bc_acc_type === 'Bank' ? 'Eg:- ICICI Current A/C, SBI FD, etc...' : 'Eg:- Petty cash, Cash on hand, etc...',
      "persistent-hint": ""
    },
    model: {
      value: (_vm.lAcc.bc_acc_name),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "bc_acc_name", $$v)
      },
      expression: "lAcc.bc_acc_name"
    }
  })], 1), _vm._v(" "), (_vm.lAcc.bc_acc_type === 'Bank') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "rules": [_vm.rules.required],
      "items": _vm.bankTypes
    },
    on: {
      "input": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lAcc.bank_acc_type),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "bank_acc_type", $$v)
      },
      expression: "lAcc.bank_acc_type"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [_c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('v-card-text', [(_vm.lAcc.no_tran_yet || _vm.sAction === 'update-balance') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.lAcc.no_tran_yet ? 'Opening balance' : 'New balance',
      "hide-details": "",
      "type": "number"
    },
    on: {
      "input": function($event) {
        return _vm.updateBal()
      }
    },
    model: {
      value: (_vm.lAcc.bc_acc_bal),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "bc_acc_bal", $$v)
      },
      expression: "lAcc.bc_acc_bal"
    }
  })], 1), _vm._v(" "), (_vm.sAction === 'update-balance') ? _c('v-flex', {
    staticClass: "mt-4 text-xs-center caption",
    staticStyle: {
      "border": "1px solid orange"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "subheading"
  }, [_vm._v("Difference:\n                              "), _c('span', {
    staticClass: "subheading info--text"
  }, [_vm._v(_vm._s(_vm.handy.formatCur(_vm.lAcc.bal_diff)))])])]) : _vm._e(), _vm._v(" "), (_vm.sAction === 'update-balance' && ((_vm.lAcc.bank_acc_type !== 'Loan' && _vm.lAcc.bal_diff > 0) || (_vm.lAcc.bank_acc_type === 'Loan' && _vm.lAcc.bal_diff < 0))) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Reason for difference",
      "rules": [_vm.rules.required],
      "items": _vm.incomeHeads,
      "item-value": "gl_acc_id",
      "item-text": "gl_acc_name",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.lAcc.credit_gl_acc_id),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "credit_gl_acc_id", $$v)
      },
      expression: "lAcc.credit_gl_acc_id"
    }
  })], 1) : (_vm.sAction === 'update-balance' && _vm.lAcc.bal_diff !== 0) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Reason for difference'",
      "rules": [_vm.rules.required],
      "items": _vm.expHeads,
      "item-value": "gl_acc_id",
      "item-text": "gl_acc_name",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.lAcc.debit_gl_acc_id),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "debit_gl_acc_id", $$v)
      },
      expression: "lAcc.debit_gl_acc_id"
    }
  })], 1) : _vm._e()], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Balance ")]), _vm._v(" "), _c('div', {
    staticClass: "title info--text"
  }, [_vm._v(_vm._s(_vm.handy.formatCur(_vm.lAcc.bc_acc_bal)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.sAction = 'update-balance'
      }
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Min balance",
      "hide-details": "",
      "disabled": !_vm.lAcc.is_alert_min_bal
    },
    model: {
      value: (_vm.lAcc.min_bal),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "min_bal", $$v)
      },
      expression: "lAcc.min_bal"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-switch', {
    staticClass: "mt-3",
    attrs: {
      "label": _vm.$vuetify.breakpoint.smAndUp ? 'Min balance alert' : 'Alert',
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lAcc.is_alert_min_bal),
      callback: function($$v) {
        _vm.$set(_vm.lAcc, "is_alert_min_bal", $$v)
      },
      expression: "lAcc.is_alert_min_bal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.deleteAcc($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": _vm.beingSaved,
      "color": "accent"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/46.9fd8e95e4df1b5f6eafb.js